import { FUND_ENTITY_ALIAS, SECURITY_ALIAS, SHARES_ALIAS } from 'common/constants/fund-ownership';
import { IS_REQUIRED_ERROR, SHARES_EXCEEDS_CAPTABLE_SHARES, WARNING_CLASSNAME } from 'common/constants/messages/validations';
import { sumArrayValues, toString } from 'utilities';
import { FundOwnershipTableData } from '../models/fund-ownership.models';
import { FundOwnershipCell } from '../types';

// Sum a security's shares across the given cells. Callers must pass the FULL
// sheet's cells: an edit pass validates only the changed cells, and summing
// just those would understate the aggregate.
const getOwnershipTotalShares = (cells: FundOwnershipCell[], securityId: number) =>
  sumArrayValues(
    cells
      .filter(
        item => item.alias === SHARES_ALIAS && item.value && toString(item.relatedSecurity) === toString(securityId)
      )
      .map(item => Number(item.value))
  );

const customValidations = ({
  cell,
  cellsToValidate,
  parsedColumns,
  tableData,
  addFeedback,
  removeFeedback,
}: {
  cell: FundOwnershipCell;
  cellsToValidate: FundOwnershipCell[];
  parsedColumns?: Record<string, FundOwnershipCell>;
  tableData: FundOwnershipTableData;
  addFeedback: (message: string, validationType?: string) => void;
  removeFeedback: (message: string, validationType?: string) => void;
}) => {
  const { capTable: capTableInfo } = tableData || {};
  const { alias, relatedSecurity } = cell;

  switch (alias) {
    case SECURITY_ALIAS:
    case FUND_ENTITY_ALIAS:
      if (!cell.readOnly && cell.value === 0) {
        addFeedback(IS_REQUIRED_ERROR);
      }
      break;
    case SHARES_ALIAS:
      if (cellsToValidate?.length && capTableInfo) {
        const { securities } = capTableInfo;
        const captableSecurity = securities?.find(s => toString(s.id) === toString(relatedSecurity));
        // The security's aggregate comes from the full sheet map (edited values
        // live there too), so a single-cell edit pass still sees every row.
        const sheetCells = parsedColumns ? Object.values(parsedColumns) : cellsToValidate;
        // The backend accepts FO shares exceeding the cap table (e.g. from ilevel sync), so this is
        // a non-blocking warning rather than a save-blocking error. Clear it when the condition lifts.
        if (
          captableSecurity
          && getOwnershipTotalShares(sheetCells, relatedSecurity!) > Number(captableSecurity.shares_outstanding)
        ) {
          addFeedback(SHARES_EXCEEDS_CAPTABLE_SHARES, WARNING_CLASSNAME);
        } else {
          removeFeedback(SHARES_EXCEEDS_CAPTABLE_SHARES, WARNING_CLASSNAME);
        }
      }
      break;
    default:
      break;
  }
};

export default customValidations;
